export default "__VITE_ASSET__CdCdDUuw__"